import { useContext, useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { useKustomerChatSupport } from "@hopper-b2b/self-serve";
import { B2B_PORTAL_AUTH_REDIRECT_TO } from "@hopper-b2b/types";

import { fetchUserInfo } from "../../../api/session/userInfo";
import { UserContext } from "../../../App";
import { PATH_AUTH_INVALID_SESSION } from "../../../utils/urlPaths";

interface IProtectedRouteProps {
  protectedUrl: string;
  protectedContent: (pathname: string) => JSX.Element;
}

const ProtectedRoute = (props: IProtectedRouteProps) => {
  const { protectedUrl, protectedContent } = props;
  const { setHopperUserId, setKustomerAccessToken } = useKustomerChatSupport();
  const [authenticated, setAuthenticated] = useState(false);
  const { sessionInfo, updateSessionInfo } = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    const userInfoCall = async () => {
      try {
        const userInfo = await fetchUserInfo({});
        updateSessionInfo?.({
          ...sessionInfo,
          userInfoResponse: {
            ...(sessionInfo?.userInfoResponse || {}),
            ...userInfo,
          },
        });
        setAuthenticated(true);
        setHopperUserId?.(sessionInfo.hopperUserId);
        setKustomerAccessToken?.(userInfo.kustomerAccessToken);
      } catch (err) {
        const redirectUrl = `${history.location.pathname}${history.location.search}`;
        if (!redirectUrl.includes("/auth/")) {
          sessionStorage.setItem(B2B_PORTAL_AUTH_REDIRECT_TO, redirectUrl);
        }
        // TODO: before deploying to prod remove
        // should be refreshing the token with a new access_token?
        history.push(PATH_AUTH_INVALID_SESSION);
      }
    };
    // userInfo validates both Nequi and Hopper sessions, returning the NequiUserDetails if both are valid.
    if (!authenticated) userInfoCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, sessionInfo]);

  return (
    <Route
      path={protectedUrl}
      render={(prop) =>
        authenticated ? protectedContent(prop.history.location.pathname) : null
      }
    />
  );
};

export default ProtectedRoute;
